import { render, staticRenderFns } from "./WhatsappTemplateGallery.vue?vue&type=template&id=7b5da84e&scoped=true&"
import script from "./WhatsappTemplateGallery.vue?vue&type=script&lang=js&"
export * from "./WhatsappTemplateGallery.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappTemplateGallery.vue?vue&type=style&index=0&id=7b5da84e&lang=scss&scoped=true&"
import style1 from "./WhatsappTemplateGallery.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5da84e",
  null
  
)

export default component.exports